<template>
	<div :style="mainStyle" class="wrapper">
		<el-tabs class="box-card" v-model="registerName" :stretch="true" type="border-card">
			<el-tab-pane label="立即注册" name="register" class="tab-panel">
				<el-form class="active-form"
								 :model="registerForm"
								 :rules="rules"
								 v-loading="loading"
								 ref="registerForm">
					<el-form-item label="请输入公司名称" prop="companyName">
						<el-input placeholder="请输入公司名称" v-model="registerForm.companyName" ></el-input>
					</el-form-item>
					<el-form-item label="请输入手机号码" prop="phone">
						<el-input placeholder="请输入您的手机号码" v-model="registerForm.phone" ></el-input>
					</el-form-item>
					<el-form-item label="请输入用户名" prop="username">
						<el-input placeholder="请输入您的用户名" v-model="registerForm.username" ></el-input>
					</el-form-item>
					<el-form-item label="请输入密码" prop="password">
						<el-input type="password" placeholder="请输入密码"
											@keyup.enter.native="" v-model="registerForm.password" ></el-input>
					</el-form-item>
					<el-form-item label="请再次输入密码" prop="passwordAg">
						<el-input placeholder="请再次输入密码" v-model="registerForm.passwordAg" ></el-input>
					</el-form-item>
					<el-form-item label="请输入验证码" prop="code" class="login-code-item" >
						<el-input placeholder="请输入验证码" @keyup.enter.native="registerHandler" v-model="registerForm.code" >
							<template>
								<template slot="append">
									<el-button @click="getRegisterCode" class="code-btn" :disabled="codeBtnDisabled">{{loginCodeMsg}}</el-button>
								</template>
							</template>
						</el-input>
					</el-form-item>
					<el-button class="login-btn" type="primary" @click="registerHandler">确定</el-button>
					<div style="line-height: 30px;margin-top: 10px;font-size: 14px;text-decoration: underline;color:#409EFF;cursor: pointer;">
						<span @click="backToLogin" style="width: 50%;display: inline-block;">已有账号,返回登录</span>
					</div>
				</el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import config from "../../config/global.js";

	var getCodeUrl = config.host+"/backend/org/registercode.json";
	var regiseterUrl = config.host + "/backend/org/addorg.json";

    export default {
        name: "register-panel",
			data:function () {
				var samePasswordValidator = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入密码'));
					} else {
						if (this.registerForm.passwordAg !== '') {
							this.$refs.registerForm.validateField('passwordAg');
						}
						callback();
					}
				};
				var samePasswordValidatorAg = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请再次输入密码'));
					} else if (value !== this.registerForm.password) {
						callback(new Error('两次输入密码不一致!'));
					} else {
						callback();
					}
				};

				return {
					registerForm:{},
					registerName:"register",
					mainStyle:{"width":'100%',"height":window.innerHeight+"px","display":"flex","justify-items":"center","align-items":"center"},
					registerForm: {
						companyName:"",
						phone:"",
						password: "",
						passwordAg:"",
						username:"",
						code:""
					},
					loading: false,
					fetching:false,
					timer:null,
					loginCodeMsg:"获取验证码",
					codeBtnDisabled:false,
					rules: {
						companyName:[{ required: true, message: '请输入公司名称', trigger: 'blur'  }],
						phone:[{ required: true, message: '请输手机号码', trigger: 'blur'  }],
						username:[{ required: true, message: '请输用户名', trigger: 'blur'  }],
						password: [
							{ validator: samePasswordValidator, trigger: 'blur' }
						],
						passwordAg: [
							{ validator: samePasswordValidatorAg, trigger: 'blur' }
						],
						code: [
							{ required: true, message: '请输入验证码', trigger: 'blur' }
						]
					},
				}
			},
			methods:{
				getRegisterCode:function () {
					if(this.registerForm.phone == ""){
						this.$message.error("手机号码不能为空");
						return;
					}
					if(this.loading == false && this.fetching == false ){
						this.fetching = true;
						this.loading == true;
						var params = {"phone":this.registerForm.phone,"type":2};
						this.$http.post(getCodeUrl,params).then(
							function(response){
								var res = response.body;
								this.buildCodeMsg();
								if(res.result==1){
									this.$message({
										message: "验证码已发送",
										type: "success"
									});
								}else{
									this.$message.error(res.emsg);
								}
								this.loading=false;
								this.fetching = false;
							},function(){
								this.$message.error("获取验证码失败");
								this.loading=false;
								this.fetching = false;
							})
					}
				},
				buildCodeMsg:function () {
					var cSecond = 60;
					this.loginCodeMsg = "重新发送("+cSecond+")";
					if(this.timer != null)
						clearInterval(this.timer);
					this.codeBtnDisabled = true;
					var _this = this;
					this.timer = setInterval(function(){
						cSecond--;
						_this.loginCodeMsg = "重新发送("+cSecond+")";
						if(cSecond == 0){
							_this.loginCodeMsg = "获取验证码";
							_this.fetching = false;
							_this.codeBtnDisabled = false;
							clearTimeout(_this.timer);
						}
					},1000);
				},
				registerHandler:function () {
					this.$refs["registerForm"].validate((valid) => {
						if (valid) {
							this.loading=true;
							var params = {};
							params.phone = this.registerForm.phone;
							params.code = this.registerForm.code;
							params.companyname = this.registerForm.companyName;
							params.username = this.registerForm.username;

							this.$http.post(regiseterUrl,params).then(
								function(response){
									var res = response.body;
									if(res.result==1){
										this.$router.replace({"name":"index"});
									}else{
										this.$message.error(res.emsg);
									}
									this.loading=false;
								},function(){
									this.$message.error("注册失败");
									this.loading=false;
								})
						} else {
							return false
						}
					})
				},
				backToLogin:function () {
					this.$router.replace({"name":"login"});
				}
			}
    }
</script>

<style scoped>
	.wrapper>>>.el-card__body{
		padding: 0px;
	}

	.wrapper>>>.el-form-item__label{
		color: rgb(175, 175, 175);
		font-size: 13px;
		font-weight: 400;
	}
	.wrapper>>>.el-tabs__item.is-top{
		line-height: 40px;
		height: 40px;
		font-size: 18px;
	}
	.wrapper>>>.el-tabs__content{
		padding: 10px 25px;
	}

	.wrapper>>>.el-form-item{
		margin-bottom: 0px;
	}

	.wrapper>>>.el-input__inner{
		border: 1px solid #eaeff1;
		background: #fbfbfb;
		box-shadow: none;
		border-radius: 3px;
		height: 40px;
		font-size: 12px;
		padding: 4px 16px;
	}

	.wrapper>>>.el-input__inner:focus{
		border-color: #409EFF;
		outline: 0;
		box-shadow: 0 0 8px #409EFF;
	}

	.wrapper>>>.el-form-item.is-error .el-input__inner{
		border-color: #F56C6C;
		box-shadow: 0 0 8px #F56C6C;
	}

	.wrapper>>>.el-form-item__error{
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		position: absolute;
		top: 40px;
		right: 10px;
		line-height: 40px;
		padding-top: 0px;
		left: inherit;
	}

	.wrapper>>>.login-code-item .el-form-item__error {
		right: 130px;
	}

	.box-card{
		width:400px;
		height:650px;
		margin: -25px auto 0 auto;
		border-radius: 0 0 5px 5px;
	}
	.title{
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
		font-size: 22px;
		text-align: center;
		margin: 20px auto 30px ;
	}
	.error{
		text-align: center;
		color: red;
		margin: -10px 0 10px 0;
	}

	.tab-panel{
		width: 100%;
		height: 100%;
	}

	.login-form{
		width: 100%;
		height: 280px;
	}

	.login-btn{
		width: 100%;
		margin-top: 20px;
	}

	.code-btn{
		width: 125px;
		font-size: 13px;
	}

	.el-button.is-disabled{
		color: #C0C4CC;
		cursor: not-allowed;
		background-image: none;
		background-color: #FFF;
		border-color: #EBEEF5;
	}
</style>



// WEBPACK FOOTER //
// src/pages/RegisterPanel.vue